const degreesToRadians = (degrees) => (degrees * Math.PI) / 180;

export { degreesToRadians };



//////////////////
// WEBPACK FOOTER
// ./node_modules/popmotion/dist/es/utils/degrees-to-radians.mjs
// module id = wbZd
// module chunks = 0